import * as React from "react";
import { useFormContext, get } from "react-hook-form";

export const ErrorMessage = ({name}: {name: string}) => {
    const { formState: { errors } } = useFormContext();

    const error: any = get(errors, name);

    return (
        <>
            {error && <span className="error-message">{ error.message }</span>}
        </>
    );
}